export default __webpack_public_path__ + "assets/images/decor_small.89c55b.png";